(function(){
  var d = document, root = d.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO = 'IntersectionObserver' in window;

  /* Test gamme : nom court du produit (sans le titre SEO) */
  [].forEach.call(d.querySelectorAll('.shl-qz__name'), function (n) {
    n.textContent = n.textContent.split(' - ')[0].split(' \u2013 ')[0].split(' | ')[0].split(' pour ')[0].trim();
  });

  /* Marque : chaque « So.lab » visible devient le logo Solab + rond */
  (function () {
    var re = /So\.lab/gi, skip = /^(SCRIPT|STYLE|NOSCRIPT|TEXTAREA|INPUT|OPTION|SELECT|TITLE|svg|SVG)$/;
    var walker = d.createTreeWalker(d.body, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        if (!re.test(n.nodeValue)) { re.lastIndex = 0; return NodeFilter.FILTER_REJECT; }
        re.lastIndex = 0;
        for (var p = n.parentNode; p && p !== d.body; p = p.parentNode) {
          if (skip.test(p.nodeName) || (p.classList && (p.classList.contains('shl-brand') || p.classList.contains('shl-hd__logo') || p.classList.contains('shl-ft__logo'))) || p.isContentEditable) return NodeFilter.FILTER_REJECT;
        }
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function (n) {
      var par = n.parentNode, parts = n.nodeValue.split(re);
      var frag = d.createDocumentFragment();
      parts.forEach(function (t, i) {
        if (t) frag.appendChild(d.createTextNode(t));
        if (i < parts.length - 1) {
          var s = d.createElement('span');
          s.className = 'shl-brand';
          s.textContent = 'Solab';
          frag.appendChild(s);
        }
      });
      var disp = '';
      try { disp = window.getComputedStyle(par).display; } catch (e) {}
      if (/flex|grid/.test(disp)) {
        var w = d.createElement('span');
        w.appendChild(frag);
        par.replaceChild(w, n);
      } else {
        par.replaceChild(frag, n);
      }
    });
  })();

  /* Lumiere ambiante du fond (statique, aucun element anime) */
  if (!d.querySelector('.shl-fall')) {
    var amb = d.createElement('div');
    amb.className = 'shl-fall';
    amb.setAttribute('aria-hidden', 'true');
    d.body.insertBefore(amb, d.body.firstChild);
  }

  /* 1. Souffle botanique : feuilles ancrees aux extremites du hero (accueil et pages) */
  var hero = d.querySelector('.shl-hero, [data-shl-leaves]');
  var leaves = window.SHL_LEAVES || [];
  if (hero && leaves.length) {
    leaves.forEach(function (src, i) {
      if (!src) return;
      var w = d.createElement('div');
      w.className = 'shl-leaf shl-leaf--' + (i ? 'b' : 'a');
      w.setAttribute('aria-hidden', 'true');
      var im = new Image();
      im.alt = '';
      im.decoding = 'async';
      im.className = 'shl-leaf__img';
      im.onload = function () { w.classList.add('is-ready'); };
      im.onerror = function () { w.remove(); };
      im.src = src;
      w.appendChild(im);
      hero.appendChild(w);
    });
    if (!reduce) {
      hero.classList.add('has-leaves-anim');
      var visible = true, ticking = false;
      var desk = window.matchMedia('(min-width: 750px)');
      if (hasIO) {
        new IntersectionObserver(function (es) {
          visible = es[0].isIntersecting;
          hero.classList.toggle('is-paused', !visible);
        }).observe(hero);
      }
      var update = function () {
        ticking = false;
        if (!visible || !desk.matches) return;
        var y = window.pageYOffset || 0;
        hero.style.setProperty('--leaf-y', (y * 0.08).toFixed(1) + 'px');
        hero.style.setProperty('--leaf-y2', (y * -0.05).toFixed(1) + 'px');
      };
      window.addEventListener('scroll', function () {
        if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
      }, { passive: true });
    }
  }

  if (reduce || !hasIO) return;
  root.classList.add('shl-motion');

  /* 2. Apparition au defilement (elements sous la ligne de flottaison uniquement, une seule fois) */
  var sel = '.shl .shl-h2:not(.shl-rit__title), .shl-goal, .shl-bento__card, .shl-tile, .shl-card, .shl-ipl__card, .shl-psp__media, .shl-pcd__card, .shl-acard, .shl-pst__in, .shl-pcta__box, .shl-axr__card, .shl-axr__scene, .shl-axs__media, .shl-axs__step, .shl-axt__col, .shl-axf__item, .shl-axc__box, [data-rv]';
  var vh = window.innerHeight;
  var els = [].slice.call(d.querySelectorAll(sel)).filter(function (el) {
    return el.getBoundingClientRect().top > vh * 0.92;
  });
  els.forEach(function (el) {
    var idx = 0, p = el.parentElement;
    if (p) idx = [].indexOf.call(p.children, el) % 5;
    el.style.setProperty('--rv-d', (idx * 90) + 'ms');
    el.classList.add('shl-rv');
  });
  var rio = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (!e.isIntersecting) return;
      var el = e.target;
      rio.unobserve(el);
      el.classList.add('is-rv');
      var delay = parseInt(el.style.getPropertyValue('--rv-d') || '0', 10) || 0;
      setTimeout(function () {
        el.classList.remove('shl-rv', 'is-rv');
        el.style.removeProperty('--rv-d');
      }, 950 + delay);
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
  els.forEach(function (el) { rio.observe(el); });

  /* 3. Trace lumineux : cartes de gammes (accueil) et cartes d'actifs, une fois a l'apparition */
  var goals = [].slice.call(d.querySelectorAll('.shl-goal, .shl-axr__card'));
  if (goals.length) {
    var gio = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        gio.unobserve(e.target);
        var i = [].indexOf.call(e.target.parentElement.children, e.target);
        setTimeout(function () {
          e.target.classList.add('is-trace');
          setTimeout(function () { e.target.classList.remove('is-trace'); }, 1800);
        }, 450 + i * 180);
      });
    }, { threshold: 0.5 });
    goals.forEach(function (g) { gio.observe(g); });
  }
})();
